<div>
  <json-editor
    #editor
    [options]="editorOptions"
    [data]="data() || {}"
  />
</div>
